/* Page template par variant switching — bina /products/... redirect ke.
   Dawn ka variant handler block karke sab kuch client side handle karta hai:
   URL ?variant=, cart ka hidden id input, price, button state, gallery image.
*/
(function () {
  'use strict';

  var D = window.PAGE_VARIANT;
  if (!D || !D.variants || !D.variants.length) return;

  var current = null;

  function log() {
    if (window.PV_DEBUG) console.log.apply(console, ['[pv]'].concat([].slice.call(arguments)));
  }

  /* ---------- money ---------- */

  function formatMoney(cents) {
    var format = D.moneyFormat || '{{amount}}';
    var value = '';

    function withCommas(num, decimals, thousand, decimal) {
      var n = (cents / 100.0).toFixed(decimals);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousand);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }

    // Indian grouping (1,23,456) ke liye
    function indian(decimals, decimal) {
      var n = (cents / 100.0).toFixed(decimals);
      var parts = n.split('.');
      var x = parts[0];
      var last3 = x.slice(-3);
      var rest = x.slice(0, -3);
      if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
      return parts.length > 1 ? last3 + decimal + parts[1] : last3;
    }

    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var token = match ? match[1] : 'amount';

    switch (token) {
      case 'amount': value = withCommas(2, ',', '.'); break;
      case 'amount_no_decimals': value = withCommas(0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withCommas(2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withCommas(0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withCommas(2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withCommas(0, ' ', ','); break;
      case 'amount_with_space_separator': value = withCommas(2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withCommas(2, ' ', '.'); break;
      default: value = withCommas(2, ',', '.');
    }

    if (/^\s*₹/.test(format)) value = indian(format.indexOf('no_decimals') > -1 ? 0 : 2, '.');

    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- variant lookup ---------- */

  function pickers() {
    return Array.prototype.slice.call(
      document.querySelectorAll('variant-radios, variant-selects')
    );
  }

  function readOptions(host) {
    var values = [];

    host.querySelectorAll('fieldset').forEach(function (fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) values.push(checked.value);
    });

    if (!values.length) {
      host.querySelectorAll('select').forEach(function (sel) {
        if (sel.value) values.push(sel.value);
      });
    }

    return values;
  }

  function findVariant(values) {
    if (!values.length) return null;
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (String(v.options[j]) !== String(values[j])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function variantById(id) {
    for (var i = 0; i < D.variants.length; i++) {
      if (String(D.variants[i].id) === String(id)) return D.variants[i];
    }
    return null;
  }

  /* ---------- UI updates ---------- */

  function syncPickers(variant, except) {
    pickers().forEach(function (host) {
      if (host === except) return;

      host.querySelectorAll('fieldset').forEach(function (fs, idx) {
        var want = variant.options[idx];
        var input = fs.querySelector('input[value="' + CSS.escape(String(want)) + '"]');
        if (input && !input.checked) input.checked = true;
      });

      host.querySelectorAll('select').forEach(function (sel, idx) {
        var want = variant.options[idx];
        if (want != null && sel.value !== want) sel.value = want;
      });
    });

    // option label ke aage dikhne wala selected value
    document.querySelectorAll('.form__label-info').forEach(function (el, idx) {
      var want = variant.options[idx];
      if (want != null) el.innerHTML = '&ndash;&nbsp;' + want;
    });
  }

  function updateUrl(variant) {
    // Page ka apna URL rakhte hain — product URL par redirect NAHI karte
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({ variant: variant.id }, '', url.toString());
  }

  function updateFormInputs(variant) {
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variant.id;
      input.disabled = false;
      input.removeAttribute('disabled');
    });
  }

  function updatePrice(variant) {
    document.querySelectorAll('.price').forEach(function (price) {
      var onSale = variant.compare_at_price > variant.price;

      price.classList.toggle('price--on-sale', onSale);
      price.classList.toggle('price--sold-out', !variant.available);

      var regular = price.querySelectorAll('.price__regular .price-item--regular');
      var sale = price.querySelectorAll('.price__sale .price-item--sale, .price__sale .price-item--regular');
      var compare = price.querySelectorAll('.price-item--regular.price__compare, s.price-item--regular, .price__sale s');

      regular.forEach(function (el) { el.innerHTML = formatMoney(variant.price); });
      sale.forEach(function (el) {
        if (el.tagName === 'S' || el.classList.contains('price__compare')) return;
        el.innerHTML = formatMoney(variant.price);
      });
      compare.forEach(function (el) {
        el.innerHTML = onSale ? formatMoney(variant.compare_at_price) : '';
      });

      if (!regular.length && !sale.length) {
        var any = price.querySelector('.price-item');
        if (any) any.innerHTML = formatMoney(variant.price);
      }
    });
  }

  function updateButtons(variant) {
    document.querySelectorAll('.product-form__submit').forEach(function (btn) {
      if (btn.type !== 'submit') return;
      btn.disabled = !variant.available;
      var text = variant.available ? D.addToCartText : D.soldOutText;
      if (btn.textContent.trim() !== text) btn.textContent = text;
    });

    // Dawn/custom theme ke dynamic checkout wrapper
    document.querySelectorAll('.paymentBtnWrapper').forEach(function (el) {
      el.style.display = variant.available && variant.inventory_policy !== 'continue' ? '' : 'none';
    });

    // Notify / sold out switcher (is theme me maujood hai)
    document.querySelectorAll('.payment_custom_btn').forEach(function (wrap) {
      if (!wrap.classList.contains('notify_fun_on')) return;
      var notify = wrap.querySelector('.pdp-notify-button');
      var form = wrap.querySelector('.btn_main_payments');
      if (notify) notify.style.display = variant.available ? 'none' : 'block';
      if (form) form.style.display = variant.available ? 'block' : 'none';
    });
  }

  function updateSku(variant) {
    var sku = document.getElementById('sku-' + D.sectionId);
    if (sku) sku.textContent = variant.sku || '';
  }

  function updateMedia(variant) {
    if (!variant.featured_media_id) return;
    var target = D.sectionId + '-' + variant.featured_media_id;

    // 1) Theme ke apne thumbnail button se switch — slider logic bhi chalti hai
    var thumb = document.querySelector('[data-target="' + target + '"] button');
    if (thumb) { thumb.click(); return; }

    // 2) Dawn ka media gallery API
    var gallery = document.querySelector('media-gallery');
    if (gallery && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(target, true);
      return;
    }

    // 3) Manual fallback
    var slide = document.querySelector('[data-media-id="' + target + '"]');
    if (!slide) return;
    document.querySelectorAll('.product__media-item').forEach(function (el) {
      el.classList.remove('is-active');
    });
    slide.classList.add('is-active');
    var slider = slide.closest('.slider');
    if (slider) slider.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    else slide.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  /* ---------- main ---------- */

  function apply(variant, source) {
    if (!variant || (current && current.id === variant.id)) return;
    current = variant;
    log('variant ->', variant.id, variant.title);

    updateUrl(variant);
    updateFormInputs(variant);
    syncPickers(variant, source);
    updatePrice(variant);
    updateButtons(variant);
    updateSku(variant);
    updateMedia(variant);

    document.dispatchEvent(new CustomEvent('page-variant:change', { detail: { variant: variant } }));
  }

  function handle(host) {
    var variant = findVariant(readOptions(host));
    if (variant) apply(variant, host);
    else log('is combination ka variant nahi mila');
  }

  /* Dawn ka handler block: document capture par rok dete hain,
     isse variant-radios / variant-selects ka apna listener chalta hi nahi
     aur /products/... par redirect nahi hota. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var host = t.closest('variant-radios, variant-selects');
    if (!host) return;

    e.stopImmediatePropagation();
    handle(host);
  }, true);

  /* Initial load: URL ka ?variant= respect karo */
  function init() {
    var id = new URL(window.location.href).searchParams.get('variant');
    var variant = id ? variantById(id) : null;

    if (!variant) {
      var host = pickers()[0];
      variant = host ? findVariant(readOptions(host)) : null;
    }
    if (!variant) {
      for (var i = 0; i < D.variants.length; i++) {
        if (D.variants[i].available) { variant = D.variants[i]; break; }
      }
    }
    if (!variant) variant = D.variants[0];

    apply(variant);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.PageVariant = { apply: apply, find: findVariant, byId: variantById, data: D };
})();
